module.exports = __webpack_public_path__ + "img/mockup-velaine-immo-home.348d813.png";